import{FC, useMemo } from 'external/react'

import usePackage from 'context/package-context/hook'

type SearchUserProps = {
	role: 'Student' | 'Tutor',
	search: string
}

const SearchUser: FC<SearchUserProps> = props => {

	const {role, search} = props

	const {update} = usePackage()

	function handleSearchChange (e: { target: { value: any } }) {
		update({modals: {[`select${role}`]: {search: {$set: e.target.value}}}})
	}

    return (
		<div className='col-lg-10 col-md-10 col-10'>
			<input type='text' className='form-control' value={search} onChange={handleSearchChange} />
		</div>
	)

}

export {SearchUser as default}